import { IComplex, IFileUri } from 'src/typings/complexes';
import { IPlacement } from 'src/typings/placement';
import {
  IGeneralUnitInfo, IMarketplacePagination,
  IMarketplaceProperty,
  IViewTile, NumberTransformationConfig,
  SortOrderType, ThousandsSeparator,
} from 'src/components/profileComponents/Marketplace/types';
import { ITranslate } from 'src/typings/viewConfig';
import { IMarketplaceConfigUnitsBreakDownDynamic } from 'src/typings/marketplaceTile';

export enum MarketplaceTilesType {
  CITY = 'City',
  METROSTATION = 'MetroStation',
  DISTRICT = 'District'
}

export enum MarketplaceTilesLocationMetroStationType {
  WALKINGDISTANCE = 'WalkingDistance',
  DRIVINGDISTANCE = 'DrivingDistance',
}

export enum MarketplaceTilesMinMaxRangeType {
  MINMAX = 'MinMaxDynamicPropertyWrapper',
  GROUPINGMINMAX = 'GroupingDynamicPropertyWrapper',
  MIN = 'MinDynamicPropertyWrapper',
}

export interface IMarketplaceFilterRequest {
  language: string,
  marketplaceId: number,
}

export interface IMarketplaceFilterResponse {
  complexesTile: IComplex[],
  placementsTile: IPlacement[],
  complexesMapList: IComplex[],
  filter: IMarketplaceBaseFilterResponse[],
  viewTile: IViewTile,
  generalUnitInfo: IGeneralUnitInfo,
  pagination: IMarketplacePagination;
}

export interface IMarketplaceBaseFilterResponse {
  propertyName: string,
  values: IMarketplaceFilterResponseValue[]
}

export interface IMarketplaceAllFiltersState {
  isOpen: boolean;
}

export interface IMarketplaceSubFilterResponse extends IMarketplaceBaseFilterResponse {
  oldSystemName: string | null,
}

export interface IMarketplaceFilterResponseValue {
  value: string,
  subValues: IMarketplaceSubFilterResponse[],
  unitCount: number,
}

export interface IMarketplaceLanguageObjectsData {
  marketplaceId: string,
  findProperties: string[],
}
export interface IMarketplaceLanguageObjects {
  [key: string]: { [key: string]: string }[];
}

export interface IMarketplaceTilesConfigComplexTag {
  id: number,
  sortOrder: number,
  text: ITranslate | null,
  iconFileUri: IFileUri | null,
}
export interface IMarketplaceTilesConfigComplex {
  id: number,
  sortOrder: number,
  isActive: boolean,
  complex: Partial<IComplex>,
  tags: IMarketplaceTilesConfigComplexTag[]
}

export interface IMarketplaceTilesConfigHeader {
  id: number,
  diType: string,
  property: IMarketplaceProperty | null,
  isActive: boolean,
}

export interface IMarketplaceTilesLocationValue {
  id: number,
  diType: MarketplaceTilesType,
  sortOrder: number,
  iconFileUri: IFileUri | null,
  isActive: boolean,
  prefix: ITranslate | null,
  suffix: ITranslate | null,
  isShorterDistanceOnly?: boolean,
  property?: IMarketplaceProperty | null,
  walkingDistance?: IMarketplaceTilesLocationSubValue,
  drivingDistance?: IMarketplaceTilesLocationSubValue,
}

export interface IMarketplaceTilesLocationSubValue {
  id: number,
  isActive: boolean,
  iconFileUri: IFileUri | null,
  uomText: ITranslate | null,
  property: IMarketplaceProperty | null,
}

export interface IMarketplaceTilesLocation {
  id: number,
  isMetroOrDistrict: boolean,
  values: IMarketplaceTilesLocationValue[]
  isActive: boolean,
}

export interface IMarketplaceTilesRange {
  diType: MarketplaceTilesMinMaxRangeType.MINMAX
  fromPrefix: ITranslate | null,
  toPrefix: ITranslate | null,
  isActive: boolean,
  property: IMarketplaceProperty | null,
  uomText: ITranslate | null,
  propertyValuesOrder: SortOrderType | null,
  numberTransformationConfig: NumberTransformationConfig
}
export interface IMarketplaceTilesProjectTimeline {
  isActive: boolean,
  prefix: ITranslate | null,
  suffix: ITranslate | null,
  property: IMarketplaceProperty | null,
}

export interface IMarketplaceTilesVirtualSubProperty {
  id: number,
  type: 'MinVirtualProperty',
  func: 'min' | 'max',
  property: IMarketplaceProperty | null,
  prefix: ITranslate | null,
  uomText: ITranslate | null,
}

export interface IMarketplaceTilesUnitsBreakdown {
  diType: MarketplaceTilesMinMaxRangeType.GROUPINGMINMAX,
  id: number,
  isActive: boolean,
  prefix: ITranslate | null,
  suffix: ITranslate | null,
  property: IMarketplaceProperty | null,
  groupedDynamicPropertyWrappers: IMarketplaceConfigUnitsBreakDownDynamic[],
  propertyValuesOrder: SortOrderType | null,
}

export interface IMarketplaceTilesAvailabilityCounter {
  isActive: boolean,
  prefix: ITranslate | null,
  suffix: ITranslate | null,
  numberTransformationConfig: {
    thousandsSeparator: ThousandsSeparator
  }
}

export interface IMarketplaceComplexTileConfig {
  id: number,
  complexOrderings: IMarketplaceTilesConfigComplex[],
  header: IMarketplaceTilesConfigHeader,
  location: IMarketplaceTilesLocation,
  minMaxRange: IMarketplaceTilesRange,
  projectTimeline: IMarketplaceTilesProjectTimeline,
  unitsBreakdown: IMarketplaceTilesUnitsBreakdown,
  availabilityCounter: IMarketplaceTilesAvailabilityCounter
}
